<template>
    <div class="dropdown-item" v-for="aviso in avisos" style="padding: 0rem 1rem;" :key="aviso.id_aviso"
        :style="aviso.style">
        <div data-toggle="tooltip" data-placement="top">
            <i :class="aviso.class" :title="aviso.texto"></i><span @click.stop="sacarconsola()" >{{aviso.titulo}}</span>
            <span class="float-right text-muted " v-if="aviso.numero_avisos >0 || aviso.numero_alertas>0">
                <a v-if="aviso.numero_avisos"
                    @click="cambiartotal(aviso.numero_alertas); cargarExpedienteAvisos(aviso.tipo_servicio,aviso.titulo,1)"
                    href="#"><span class="badge bg-warning float-left">{{aviso.numero_avisos}}</span></a>
                <a v-if="aviso.numero_alertas"
                    @click="cambiartotal(aviso.numero_alertas); cargarExpedienteAvisos(aviso.tipo_servicio,aviso.titulo,2)"
                    href="#">&nbsp;<span class="badge bg-danger float-right">{{aviso.numero_alertas}}</span></a>
            </span>
            <span class="float-right text-muted " v-else   @click.stop="sacarconsola()">{{aviso.texto}}</span>
        </div>
    </div>
</template>
<script>
export default({
    props:{
        avisos: Array,
        
    },
    
    setup() {

        
    },
    methods: {
        sacarconsola(){
            console.log("test");
        },
        cargarExpedienteAvisos: function(tipo,titulo,alerta){
            //alert(tipo);
            //window.location.href = "/escritorio";
            this.$emit('evento_expediente_avisos_tipo',tipo,titulo,alerta); //Es llamado por ./AvisosMenu.vue
        },
        cambiartotal(numero) {
            localStorage.setItem("numeroavisos", numero);
            // this.$parent.cambiartotalpadre(numero);
            setTimeout(() => {
                document.getElementById("avescritorio").className = "nav-link active";

            }, 500);

        },
    },
    mounted(){
    },
    watch:{
     
    }
})
</script>
